export default (function (_ref) {
  var request = _ref.request;
  return {
    sourceBatchAdd: function sourceBatchAdd(data) {
      return request({
        url: '/source/batch/add',
        method: 'post',
        data: data
      });
    },
    sourceBatchModify: function sourceBatchModify(data) {
      return request({
        url: "/source/batch/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    sourceBatchDel: function sourceBatchDel(id) {
      return request({
        url: "/source/batch/".concat(id, "/del"),
        method: 'delete'
      });
    },
    sourceBatchQuery: function sourceBatchQuery(data) {
      return request({
        url: '/source/batch/query',
        method: 'get',
        params: data
      });
    },
    sourceBatchDetail: function sourceBatchDetail(id) {
      return request({
        url: "/source/batch/".concat(id, "/detail"),
        method: 'get'
      });
    },
    sourceBatchDownQrCods: function sourceBatchDownQrCods(id) {
      return request({
        url: "/source/uniqueBatch/".concat(id, "/downQrCods"),
        method: 'get'
      });
    },
    scanReocrdQuery: function scanReocrdQuery(params) {
      return request({
        url: "/source/scanReocrd/query",
        method: 'get',
        params: params
      });
    },
    scanReocrdReport: function scanReocrdReport(labId) {
      return request({
        url: "/source/scanReocrd/".concat(labId, "/report"),
        method: 'get'
      });
    }
  };
});